<script>
  import _ from 'lodash'
  import ProfitAndLossChart from '../components/profit-and-loss-chart'
  import ProfitAndLossOverviewTable from '../components/profit-and-loss-overview-table'
  import ProfitAndLossTable from '../components/profit-and-loss-table'
  import QuestionsFormSub from '../components/questions-form-sub'
  import QuestionsTab from '../components/questions-tab';
  import QuestionsTabError from '../components/questions-tab-error';

  import VueTypes from 'vue-types'

  export default {
    name: 'ProfitAndLossForm',
    template: '#profit-and-loss-form-template',
    components: {
      'profit-and-loss-chart': ProfitAndLossChart,
      'profit-and-loss-overview-table': ProfitAndLossOverviewTable,
      'profit-and-loss-table': ProfitAndLossTable,
      'questions-form-sub': QuestionsFormSub,
      'questions-tab': QuestionsTab,
      'questions-tab-error': QuestionsTabError

    },
    props: {
      isShowChartExample: VueTypes.bool.def(false),
      isShowTableExample: VueTypes.bool.def(false),
      isShowOverviewTableExample: VueTypes.bool.def(false)
    },
    data () {
      return {
        showChartExample: this.isShowChartExample,
        showTableExample: this.isShowTableExample,
        showOverviewTableExample: this.isShowOverviewTableExample,
        
        unit: 1000000,
        negativeMark: '△',
        walfareRate: 1.3,
        serviceLife: 3,
        startYear: 0,
        startMonth: 0,
        launchYear: 0,
        launchMonth: 0,
        before: {
          personnel: 0,
          annualIncome: 0,
          advertisingExpense: 0,
          advertisingStartMonth: 0,
          capitalInv: 0,
          nonAssetCapitalInv: 0,
          rents: 0,
          otherExpense: 0
        },
        year1: {
          main: {
            price: 0,
            sellVolumePerYear: 0,
            sellVolumePerMonths: [],
            salesMargin: 0,
            productCostPerItem: 0,
            productCostPerYear: 0,
            productCostPerMonths: []
          },
          sub: {
            price: 0,
            sellVolumePerYear: 0,
            sellVolumePerMonths: [],
            salesMargin: 0,
            productCostPerItem: 0,
            productCostPerYear: 0,
            productCostPerMonths: []
          },
          sub2: {
            price: 0,
            sellVolumePerYear: 0,
            sellVolumePerMonths: [],
            salesMargin: 0,
            productCostPerItem: 0,
            productCostPerYear: 0,
            productCostPerMonths: []
          },
          personnel: 0,
          annualIncome: 0,
          advertisingExpense: 0,
          capitalInv: 0,
          nonAssetCapitalInv: 0,
          rents: 0,
          otherExpense: 0
        },
        year2: {
          main: {
            price: 0,
            sellVolumePerYear: 0,
            sellVolumePerMonths: [],
            salesMargin: 0,
            productCostPerItem: 0,
            productCostPerYear: 0,
            productCostPerMonths: []
          },
          sub: {
            price: 0,
            sellVolumePerYear: 0,
            sellVolumePerMonths: [],
            salesMargin: 0,
            productCostPerItem: 0,
            productCostPerYear: 0,
            productCostPerMonths: []
          },
          sub2: {
            price: 0,
            sellVolumePerYear: 0,
            sellVolumePerMonths: [],
            salesMargin: 0,
            productCostPerItem: 0,
            productCostPerYear: 0,
            productCostPerMonths: []
          },
          personnel: 0,
          annualIncome: 0,
          advertisingExpense: 0,
          capitalInv: 0,
          nonAssetCapitalInv: 0,
          rents: 0,
          otherExpense: 0
        },
        year3: {
          main: {
            price: 0,
            sellVolumePerYear: 0,
            sellVolumePerMonths: [],
            salesMargin: 0,
            productCostPerItem: 0,
            productCostPerYear: 0,
            productCostPerMonths: []
          },
          sub: {
            price: 0,
            sellVolumePerYear: 0,
            sellVolumePerMonths: [],
            salesMargin: 0,
            productCostPerItem: 0,
            productCostPerYear: 0,
            productCostPerMonths: []
          },
          sub2: {
            price: 0,
            sellVolumePerYear: 0,
            sellVolumePerMonths: [],
            salesMargin: 0,
            productCostPerItem: 0,
            productCostPerYear: 0,
            productCostPerMonths: []
          },
          personnel: 0,
          annualIncome: 0,
          advertisingExpense: 0,
          capitalInv: 0,
          nonAssetCapitalInv: 0,
          rents: 0,
          otherExpense: 0
        },
        children: null
      }
    },
    computed: {},

    mounted () {
      this.children = this.getChildrenQuestionField()
      this.$nextTick(() => {
        const form = this.$refs.form
        if (form) {
          this.initializeForm(form)
          this.showExample = this.isShowExample
        }
      })
    },
    methods: {
      initializeForm (form) {
        const d = this

        // サービス検討開始年月
        this.answer(form, 262, (answers) => {
          d.startYear = this.toInteger(this.getValue(answers, 0).split('/')[0])
          d.startMonth = this.toInteger(this.getValue(answers, 0).split('/')[1])
        })

        // サービス開始年月
        this.answer(form, 107, (answers) => {
          d.launchYear = this.toInteger(this.getValue(answers, 0).split('/')[0])
          d.launchMonth = this.toInteger(this.getValue(answers, 0).split('/')[1])
        })

        // 商品価格
        this.answer(form, 263, (answers) => {
          d.year1.main.price = this.toInteger(this.getValue(answers, 0))
          d.year2.main.price = this.toInteger(this.getValue(answers, 1))
          d.year3.main.price = this.toInteger(this.getValue(answers, 2))
        })

        // 商品原価(1件あたり)
        this.answer(form, 265, (answers) => {
          d.year1.main.productCostPerItem = this.isVisible(answers, 0) ? this.toInteger(this.getValue(answers, 0)) : null
          d.year2.main.productCostPerItem = this.isVisible(answers, 1) ? this.toInteger(this.getValue(answers, 1)) : null
          d.year3.main.productCostPerItem = this.isVisible(answers, 2) ? this.toInteger(this.getValue(answers, 2)) : null
        })

        // 商品原価(年ごと)
        this.answer(form, 266, (answers) => {
          d.year1.main.productCostPerYear = this.isVisible(answers, 0) ? this.toInteger(this.getValue(answers, 0)) : null
          d.year2.main.productCostPerYear = this.isVisible(answers, 1) ? this.toInteger(this.getValue(answers, 1)) : null
          d.year3.main.productCostPerYear = this.isVisible(answers, 2) ? this.toInteger(this.getValue(answers, 2)) : null
        })

        // 商品原価(月ごと)
        this.answer(form, 267, (answers) => {
          d.year1.main.productCostPerMonths = _.range(0, 12).map((m) => this.isVisible(answers, m) ? this.toInteger(this.getValue(answers, m)) : null)
          d.year2.main.productCostPerMonths = _.range(12, 24).map((m) => this.isVisible(answers, m) ? this.toInteger(this.getValue(answers, m)) : null)
          d.year3.main.productCostPerMonths = _.range(24, 36).map((m) => this.isVisible(answers, m) ? this.toInteger(this.getValue(answers, m)) : null)
        })

        // サービスマージン(%)
        this.answer(form, 270, (answers) => {
          d.year1.main.salesMargin = this.isVisible(answers, 0) ? this.toInteger(this.getValue(answers, 0)) : null
          d.year2.main.salesMargin = this.isVisible(answers, 1) ? this.toInteger(this.getValue(answers, 1)) : null
          d.year3.main.salesMargin = this.isVisible(answers, 2) ? this.toInteger(this.getValue(answers, 2)) : null
        })

        // 年間予定販売数(月単位)
        this.answer(form, 271, (answers) => {
          d.year1.main.sellVolumePerYear = null
          d.year2.main.sellVolumePerYear = null
          d.year3.main.sellVolumePerYear = null
          d.year1.main.sellVolumePerMonths = _.range(0, 12).map((m) => this.isVisible(answers, m) ? this.toInteger(this.getValue(answers, m)) : null)
          d.year2.main.sellVolumePerMonths = _.range(12, 24).map((m) => this.isVisible(answers, m) ? this.toInteger(this.getValue(answers, m)) : null)
          d.year3.main.sellVolumePerMonths = _.range(24, 36).map((m) => this.isVisible(answers, m) ? this.toInteger(this.getValue(answers, m)) : null)
        })

        // 従業員数
        this.answer(form, 272, (answers) => {
          d.before.personnel = this.toInteger(this.getValue(answers, 0))
          d.year1.personnel = this.toInteger(this.getValue(answers, 1))
          d.year2.personnel = this.toInteger(this.getValue(answers, 2))
          d.year3.personnel = this.toInteger(this.getValue(answers, 3))
        })

        // 平均年収
        this.answer(form, 273, (answers) => {
          d.before.annualIncome = this.toInteger(this.getValue(answers, 0))
          d.year1.annualIncome = this.toInteger(this.getValue(answers, 1))
          d.year2.annualIncome = this.toInteger(this.getValue(answers, 2))
          d.year3.annualIncome = this.toInteger(this.getValue(answers, 3))
        })

        // 販売前広告費
        this.answer(form, 274, (answers) => {
          d.before.advertisingExpense = this.toInteger(this.getValue(answers, 0))
        })

        // 販売前広告費投入月数
        this.answer(form, 275, (answers) => {
          d.before.advertisingStartMonth = this.toInteger(this.getValue(answers, 0))
        })

        // 広告宣伝費
        this.answer(form, 276, (answers) => {
          d.year1.advertisingExpense = this.toInteger(this.getValue(answers, 0))
          d.year2.advertisingExpense = this.toInteger(this.getValue(answers, 1))
          d.year3.advertisingExpense = this.toInteger(this.getValue(answers, 2))
        })

        // 販売前設備投資費
        this.answer(form, 277, (answers) => {
          d.before.capitalInv = this.toInteger(this.getValue(answers, 0))
        })

        // 減価償却期間
        this.answer(form, 278, (answers) => {
          d.serviceLife = this.toInteger(this.getValue(answers, 0))
        })

        // 設備投資費
        this.answer(form, 279, (answers) => {
          d.year1.capitalInv = this.toInteger(this.getValue(answers, 0))
          d.year2.capitalInv = this.toInteger(this.getValue(answers, 1))
          d.year3.capitalInv = this.toInteger(this.getValue(answers, 2))
        })

        // 非資産設備投資費
        this.answer(form, 565, (answers) => {
          d.before.nonAssetCapitalInv = this.isVisible(answers, 0) ? this.toInteger(this.getValue(answers, 0)) : 0
          d.year1.nonAssetCapitalInv = this.isVisible(answers, 1) ? this.toInteger(this.getValue(answers, 1)) : 0
          d.year2.nonAssetCapitalInv = this.isVisible(answers, 2) ? this.toInteger(this.getValue(answers, 2)) : 0
          d.year3.nonAssetCapitalInv = this.isVisible(answers, 3) ? this.toInteger(this.getValue(answers, 3)) : 0
        })

        // 生活経費
        this.answer(form, 280, (answers) => {
          d.before.rents = this.toInteger(this.getValue(answers, 0))
          d.year1.rents = this.toInteger(this.getValue(answers, 1))
          d.year2.rents = this.toInteger(this.getValue(answers, 2))
          d.year3.rents = this.toInteger(this.getValue(answers, 3))
        })

        // その他経費
        this.answer(form, 281, (answers) => {
          d.before.otherExpense = this.toInteger(this.getValue(answers, 0))
          d.year1.otherExpense = this.toInteger(this.getValue(answers, 1))
          d.year2.otherExpense = this.toInteger(this.getValue(answers, 2))
          d.year3.otherExpense = this.toInteger(this.getValue(answers, 3))
        })

        // 副収入

        // 商品価格
        this.answer(form, 283, (answers) => {
          d.year1.sub.price = this.toInteger(this.getValue(answers, 0))
          d.year2.sub.price = this.toInteger(this.getValue(answers, 1))
          d.year3.sub.price = this.toInteger(this.getValue(answers, 2))
        })

        // 商品原価(1件あたり)
        this.answer(form, 285, (answers) => {
          d.year1.sub.productCostPerItem = this.isVisible(answers, 0) ? this.toInteger(this.getValue(answers, 0)) : null
          d.year2.sub.productCostPerItem = this.isVisible(answers, 1) ? this.toInteger(this.getValue(answers, 1)) : null
          d.year3.sub.productCostPerItem = this.isVisible(answers, 2) ? this.toInteger(this.getValue(answers, 2)) : null
        })

        // 商品原価(年ごと)
        this.answer(form, 286, (answers) => {
          d.year1.sub.productCostPerYear = this.isVisible(answers, 0) ? this.toInteger(this.getValue(answers, 0)) : null
          d.year2.sub.productCostPerYear = this.isVisible(answers, 1) ? this.toInteger(this.getValue(answers, 1)) : null
          d.year3.sub.productCostPerYear = this.isVisible(answers, 2) ? this.toInteger(this.getValue(answers, 2)) : null
        })

        // 商品原価(月ごと)
        this.answer(form, 287, (answers) => {
          d.year1.sub.productCostPerMonths = _.range(0, 12).map((m) => this.isVisible(answers, m) ? this.toInteger(this.getValue(answers, m)) : null)
          d.year2.sub.productCostPerMonths = _.range(12, 24).map((m) => this.isVisible(answers, m) ? this.toInteger(this.getValue(answers, m)) : null)
          d.year3.sub.productCostPerMonths = _.range(24, 36).map((m) => this.isVisible(answers, m) ? this.toInteger(this.getValue(answers, m)) : null)
        })

        // サービスマージン(%)
        this.answer(form, 290, (answers) => {
          d.year1.sub.salesMargin = this.isVisible(answers, 0) ? this.toInteger(this.getValue(answers, 0)) : null
          d.year2.sub.salesMargin = this.isVisible(answers, 1) ? this.toInteger(this.getValue(answers, 1)) : null
          d.year3.sub.salesMargin = this.isVisible(answers, 2) ? this.toInteger(this.getValue(answers, 2)) : null
        })

        // 年間予定販売数(月単位)
        this.answer(form, 291, (answers) => {
          d.year1.sub.sellVolumePerYear = null
          d.year2.sub.sellVolumePerYear = null
          d.year3.sub.sellVolumePerYear = null
          d.year1.sub.sellVolumePerMonths = _.range(0, 12).map((m) => this.isVisible(answers, m) ? this.toInteger(this.getValue(answers, m)) : null)
          d.year2.sub.sellVolumePerMonths = _.range(12, 24).map((m) => this.isVisible(answers, m) ? this.toInteger(this.getValue(answers, m)) : null)
          d.year3.sub.sellVolumePerMonths = _.range(24, 36).map((m) => this.isVisible(answers, m) ? this.toInteger(this.getValue(answers, m)) : null)
        })
      },

      onFormChange (form) {
        this.initializeForm(form)
        this.showExample = false
      },

      answer (form, questionId, callback) {
        const question = _.find(form.children, { id: questionId })
        if (question) {
          if (!question.children) {
              question.children = question.getChildrenAnswerField()
            }
          if (callback) {
            callback(question.children, question)
          } else {
            return question.children
          }
        }
      },

      isVisible (answers, index) {
        return _.get(answers, [index, 'show'])
      },

      getValue (answers, index, defaultValue = '') {
        return _.get(answers, [index, 'value'], defaultValue)
      },

      toInteger (val) {
        return _.toInteger(_.toString(val).replace(/,/g, ''))
      },
      getChildrenQuestionField() {
        const children = []
        const keys = Object.keys(this.$refs)
        for ( let i = 0; i < keys.length; i++) {
          const key = keys[i]
          if (key.startsWith('questionField')) {
            children.push(this.$refs[key])
          }
        }
        return children
      },

    }
  }

</script>
